module.exports = __webpack_public_path__ + "838599afbbcc5ad7ea71612a8ca3370e.svg";